import { useRef, useState } from 'react'
import PageTitle from '../components/PageTitle';
import { pageTitleTexts } from '../../constants/texts/pageTitleTexts';
import { Button } from '../components/Elements';
import { buttonTexts } from '../../constants/texts/buttonTexts';
import Filters from '../components/PaymentSetList/Filters';
import { NavLink } from 'react-router-dom';
import PaymentSetTable from '../components/PaymentSetList/PaymentSetTable';
import { getNavigationUrl } from '../../common/helpers/navigationHelpers';
import useAdminCheck from '../../hooks/useAdminCheck';

const PaymentSetList = () => {

    useAdminCheck();
    const formFilterRef = useRef<HTMLDivElement | null>(null);

    const [filtersIsOpen, setFiltersIsOpen] = useState<boolean>(true);

    let insertUpdatePaymentSet = "/odeme-seti-ekle";
    insertUpdatePaymentSet = getNavigationUrl(insertUpdatePaymentSet);

    return (
        <div className='w-full'>
            <PageTitle title={pageTitleTexts.paymentSetList} />
            <div className='px-4 pt-2 flex flex-row items-center justify-between space-y-2'>
                <div className="flex flex-row items-center">
                    <img src={"/icons/payment-sets-dark.svg"} className="h-6 w-6 black" />
                    <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
                        Ödeme Kuralı Listesi
                    </span>
                </div>

                <div className='flex flex-row justify-end items-center px-2'>
                    <Button
                        size='xs'
                        hover='gray'
                        color='gray'
                        callback={() => setFiltersIsOpen(!filtersIsOpen)}
                    >
                        <span className="mr-3">{buttonTexts.filterOpen}</span>
                        <img src="/icons/filter.svg" alt="filter" />
                    </Button>
                </div>
            </div>
            <Filters ref={formFilterRef} isOpen={filtersIsOpen} setFiltersIsOpen={setFiltersIsOpen} />
            <div className='flex flex-row-reverse pr-4 space-x-3 space-x-reverse'>
                <NavLink to={getNavigationUrl("/odeme-seti-ekle")}>
                    <Button
                        size="xs"
                        hover="primary"
                        color="primary"
                        callback={() => { }}
                    >
                        <img src="/icons/plus-white.svg" alt="add" />
                        <span className='ml-3 mr-3'>Yeni Ödeme Kuralı</span>
                    </Button>
                </NavLink>
            </div>
            <PaymentSetTable formFilterRef={formFilterRef} />
        </div>
    )
}

export default PaymentSetList;